import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import {
  emitter,
  FORCE_HIDE_RT_DIALOGS,
  YAGIBUDDY_DIALOG_CLOSED
} from '@/plugins/emitter'
import fallbackJson from '@/assets/realtime-transfer/yagibuddy-dialog.json'
import {
  mergeYagibuddyCopy,
  type YagibuddyCopy
} from '@/utils/realtime-transfer/yagibuddyCopy'


export default /*#__PURE__*/_defineComponent({
  __name: 'YagiBuddyDialog',
  setup(__props) {

const OPEN_YAGIBUDDY_POPUP_DIALOG = 'open-yagibuddy-popup-dialog'
const fallback = fallbackJson as YagibuddyCopy
const dialogVisible = ref(false)
const copy = ref<YagibuddyCopy>(fallback)
const ctaUrl = ref(fallback.ctaUrlFallback)
const showPrivacyPolicyLink = computed(() => {
  const label = copy.value.privacyPolicyLabel
  return !!label && !copy.value.privacyLabel.includes('プライバシーポリシー')
})

function onOpen(argList: unknown) {
  const args = Array.isArray(argList) ? argList : []
  const merged = mergeYagibuddyCopy(args[3], fallback)
  copy.value = merged.copy
  ctaUrl.value = merged.ctaUrl
  dialogVisible.value = true
}

function forceHide() {
  dialogVisible.value = false
}

function onVisibleInput(next: unknown) {
  dialogVisible.value = next === true
}

function closeDialog() {
  dialogVisible.value = false
}

function onModalClosed() {
  emitter.emit(YAGIBUDDY_DIALOG_CLOSED)
}

function onCtaClick() {
  window.open(ctaUrl.value, '_blank', 'noopener,noreferrer')
  closeDialog()
}

onBeforeMount(() => {
  emitter.on(OPEN_YAGIBUDDY_POPUP_DIALOG, onOpen)
  emitter.on(FORCE_HIDE_RT_DIALOGS, forceHide)
})
onBeforeUnmount(() => {
  emitter.off(OPEN_YAGIBUDDY_POPUP_DIALOG, onOpen)
  emitter.off(FORCE_HIDE_RT_DIALOGS, forceHide)
})

return { __sfc: true,OPEN_YAGIBUDDY_POPUP_DIALOG, fallback, dialogVisible, copy, ctaUrl, showPrivacyPolicyLink, onOpen, forceHide, onVisibleInput, closeDialog, onModalClosed, onCtaClick }
}

})